const escapeCsv = (value) => {
  const text = String(value ?? "");
  if (/[",\n]/.test(text)) {
    return `"${text.replace(/"/g, '""')}"`;
  }
  return text;
};

export const ACCOUNT_TYPE_OPTIONS = [
  { value: "ASSET", labelKey: "accounting.accountType.asset" },
  { value: "LIABILITY", labelKey: "accounting.accountType.liability" },
  { value: "EQUITY", labelKey: "accounting.accountType.equity" },
  { value: "REVENUE", labelKey: "accounting.accountType.revenue" },
  { value: "EXPENSE", labelKey: "accounting.accountType.expense" },
];

export const filterTrialBalanceRows = (
  rows = [],
  { searchText = "", accountTypes = [] } = {}
) => {
  let result = rows;
  if (accountTypes.length > 0) {
    result = result.filter((row) => accountTypes.includes(row.type));
  }
  const query = searchText.trim().toLowerCase();
  if (!query) return result;
  return result.filter(
    (row) =>
      row.code?.toLowerCase().includes(query) ||
      row.name?.toLowerCase().includes(query) ||
      row.type?.toLowerCase().includes(query)
  );
};

export const downloadTrialBalanceCsv = ({
  rows = [],
  report,
  periodName = "",
  asOfDate = null,
  t,
}) => {
  const formatAmount = (value) =>
    value == null || value === "" ? "0.00" : Number(value).toFixed(2);

  const lines = [
    [t("accounting.modules.trialBalance.label")],
    [
      t("Fiscal Period"),
      periodName,
      t("accounting.trialBalance.asOfDate"),
      asOfDate ? new Date(asOfDate).toLocaleDateString() : t("accounting.trialBalance.asOfDateAll"),
    ],
    [],
    [
      t("Debit"),
      t("Credit"),
      t("accounting.trialBalance.difference"),
      t("Status"),
    ],
    [
      formatAmount(report?.totalDebit),
      formatAmount(report?.totalCredit),
      formatAmount((report?.totalDebit ?? 0) - (report?.totalCredit ?? 0)),
      report?.isBalanced
        ? t("accounting.trialBalance.balanced")
        : t("accounting.trialBalance.outOfBalance"),
    ],
    [],
    [
      t("Code"),
      t("accounting.journal.account"),
      t("Type"),
      t("Debit"),
      t("Credit"),
      t("accounting.trialBalance.netBalance"),
    ],
    ...rows.map((row) => [
      row.code,
      row.name,
      row.type,
      formatAmount(row.debit),
      formatAmount(row.credit),
      formatAmount(row.balance),
    ]),
  ];

  const csv = `\uFEFF${lines.map((line) => line.map(escapeCsv).join(",")).join("\n")}`;
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  const stamp = new Date().toISOString().slice(0, 10);
  link.href = url;
  link.download = `trial-balance-${periodName || stamp}.csv`;
  link.click();
  URL.revokeObjectURL(url);
};
